import { ENDPOINTS } from "constants/endpoints";
import axios from "axios";
import { receiptDownloader } from "component/flex/utils";

export const fetchCreditBalance = async ({ currency, businessId, range }) => {
    const params = new URLSearchParams({
        currency,
        range,
    });
    try {
        const response = await axios.get(`/v1/finance/new/summary`, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchCreditWallets = async ({ currency, businessId }) => {
    const params = new URLSearchParams({
        currency,
    });
    try {
        const response = await axios.get(ENDPOINTS.financeCreditWallet, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchCreditGroups = async ({ currency, businessId, ...rest }) => {
    const params = new URLSearchParams({
        currency,
        ...rest,
    });
    try {
        const response = await axios.get(ENDPOINTS.getAllGroupedFinance, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchSingleCredit = async ({ businessId, financeId }) => {
    try {
        const response = await axios.get(ENDPOINTS.getAllSingleFinance(financeId), {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchRepaymentWallet = async ({ businessId, currency }) => {
  const params = new URLSearchParams({
    currency,
  });
  try {
    const response = await axios.get(ENDPOINTS.getRepaymentWallet, {
      headers: {
        "x-business-id": businessId,
      },
      params
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const fetchNewWallets = async ({ businessId }) => {
  try {
    const response = await axios.get(ENDPOINTS.getNewWallets(), {
      headers: {
        "x-business-id": businessId,
      },
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const fetchAccountWallets = async ({ businessId }) => {
  try {
    const response = await axios.get(ENDPOINTS.accountWallets(), {
      headers: {
        "x-business-id": businessId,
      },
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const fetchAllFinancePay = async ({ businessId, ...rest }) => {
    const params = new URLSearchParams({
        ...rest,
    });
    try {
        const response = await axios.get(ENDPOINTS.getAllFinancePay, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};
export const fetchAllFinance = async ({ businessId, ...rest }) => {
    const params = new URLSearchParams({
        ...rest,
    });
    try {
        const response = await axios.get(ENDPOINTS.getAllFinance, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchBusinessDocuments = async ({ businessId }) => {
    try {
        const response = await axios.get(ENDPOINTS.getAllBusinessDocs, {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchFinanceActivities = async ({ businessId, financeId }) => {
    try {
      const response = await axios.get(ENDPOINTS.getFinanceActivitiesNewMethod(financeId), {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchInboundOrders = async ({ businessId, financeId }) => {
    try {
        const response = await axios.get(ENDPOINTS.getAllInboundOrders, {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const fetchOutboundOrders = async ({ businessId, financeId }) => {
    try {
        const response = await axios.get(ENDPOINTS.getAllOutboundOrders, {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const uploadFinanceBusinessDocuments = async ({ businessId, name, url }) => {
    try {
        const response = await axios.post(
            ENDPOINTS.uploadFinanceBusinessDocs,
            { name, url },
            {
                headers: {
                    "x-business-id": businessId,
                },
            }
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const createPayableFinance = async ({ businessId, data, financeId }) => {
    const params = !!financeId
        ? new URLSearchParams({
              financeId,
          })
        : undefined;
    try {
        const response = await axios.post(ENDPOINTS.cratePayableFinance, data, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const createReceivableFinance = async ({ businessId, data, financeId }) => {
    const params = !!financeId
        ? new URLSearchParams({
              financeId,
          })
        : undefined;
    try {
        const response = await axios.post(ENDPOINTS.crateReceivableFinance, data, {
            headers: {
                "x-business-id": businessId,
            },
            params,
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const createInventoryFinance = async ({ businessId, data }) => {
    try {
        const response = await axios.post(ENDPOINTS.crateInventoryFinance, data, {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const createPaymentFinance = async ({ businessId, data, financeId }) => {
    try {
        const params = !!financeId
            ? new URLSearchParams({
                  financeId,
              })
            : undefined;
    const response = await axios.post(ENDPOINTS.cratePaymentFinance, data, {
      headers: {
        "x-business-id": businessId,
      },
      params,
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const cancelFinanceRequest = async ({ businessId, id, reason, type, status }) => {
    const payload = type === "payment" ? { status: "cancelled" } : { reason };
    try {
        const response = await axios?.[type === "payment" ? "post" : "patch"](
            ENDPOINTS.cancelFinanceRequest(id, type),
            payload,
            {
                headers: {
                    "x-business-id": businessId,
                },
            }
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const deleteFinanceDraft = async ({ businessId, id, reason }) => {
    try {
        const response = await axios.delete(ENDPOINTS.deleteFinanceDraft(id), {
            headers: {
                "x-business-id": businessId,
            },
        });

        return response?.data;
    } catch (error) {
        return error;
    }
};

export const createFinancePay = async ({ businessId, data }) => {
    try {
        const response = await axios.post(ENDPOINTS.createFinancePay, data, {
            headers: {
                "x-business-id": businessId,
            },
        });
        return response?.data;
    } catch (error) {
        return error;
    }
};

export const createRepayLoan = async ({ businessId, data, financeId }) => {
    try {
        const response = await axios.post(ENDPOINTS.createRepayLoan(financeId), data, {
            headers: {
                "x-business-id": businessId,
            },
        });
        return response?.data;
    } catch (error) {
        return error;
    }
};

export const RepayLoan = async ({ businessId, data, financeId }) => {
  try {
    const response = await axios.post(ENDPOINTS.RepayLoan(financeId), data, {
      headers: {
        "x-business-id": businessId,
      },
    });
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getPublicFinance = async ({ financeId }) => {
    try {
        const { data } = await axios.get(ENDPOINTS.getPublicFinance(financeId));
        return data;
    } catch (e) {
        const status = e?.response?.status;
        const msg = e?.response?.data?.message ?? "";

        if (
            status === 400 &&
            /already taken an action on this finance/i.test(msg) &&
            typeof window !== "undefined"
        ) {
            window.location.replace("/actions/domiciliation");
            throw e;
        }

        throw e;
    }
};
export const actOnPublicFinance = async ({ financeId, status }) => {
    const { data } = await axios.post(ENDPOINTS.publicFinanceAction(financeId), { status });
    return data;
};

export const addOrUpdateUser = async (data) => {
    const { businessName, email, firstName, lastName, flexUserType, paymentInfo, phoneNumber } =
        data;
    try {
        const res = await axios.put(ENDPOINTS.addUserEndpoint(data?._id), {
            businessName,
            email,
            firstName,
            lastName,
            flexUserType,
            paymentInfo,
            phoneNumber,
        });
        return res;
    } catch (error) {
        return error;
    }
};

export const cancelWalkThrough = async () => {
    try {
        const res = await axios.put(ENDPOINTS.cancelWalkThrough);
        return res;
    } catch (error) {
        return error;
    }
};

export const downloadReceipt = async ({ financeId, subLoanId }) => {
    try {
        const res = await axios(ENDPOINTS.downloadReceipt({ financeId, subLoanId }), {
            responseType: "blob",
        });
       receiptDownloader(res, subLoanId);
        return res.data;
    } catch (error) {
        return error;
    }
};

export const downloadPaymentReceipt = async ({ paymentId }) => {
    try {
        const res = await axios(ENDPOINTS.downloadPaymentReceipt({ paymentId }), {
            responseType: "blob",
        });
        receiptDownloader(res, paymentId);
        return res.data;
    } catch (error) {
        return error;
    }
};
